import React, {
  useState,
  forwardRef,
  ForwardRefRenderFunction,
  useImperativeHandle,
} from 'react';

import Popup from 'components/Common/Popup';
import PopupActions from 'components/Common/PopupActions';

interface AlarmManagementPopupProps {
  title?: string;
  handleCloseButtonClick: () => void;
  handleCancelButtonClick: () => void;
}

export interface AlarmManagementPopupRef {
  handleOpenPopup: (open: boolean) => void;
}

const AlarmManagementPopup: ForwardRefRenderFunction<
  AlarmManagementPopupRef,
  AlarmManagementPopupProps
> = ({ title, handleCloseButtonClick, handleCancelButtonClick }, ref) => {
  const [openPopup, setOpenPopup] = useState<boolean>(false);

  const handleOpenPopup = (open: boolean) => {
    setOpenPopup(open);
  };

  useImperativeHandle(ref, () => ({
    handleOpenPopup,
  }));

  return (
    <React.Fragment>
      <Popup
        open={openPopup}
        onClose={() => {}}
        title={title}
        actions={
          <>
            <PopupActions
              actionsList={[
                {
                  title: 'Yes',
                  className: 'cancel-button',
                  onClick: handleCloseButtonClick,
                },
                {
                  title: 'No',
                  className: 'close-button',
                  onClick: handleCancelButtonClick,
                },
              ]}
            />
          </>
        }
      ></Popup>
    </React.Fragment>
  );
};

export default forwardRef<AlarmManagementPopupRef, AlarmManagementPopupProps>(
  AlarmManagementPopup
);
